// extracted by mini-css-extract-plugin
export default {"images":"DailyTvPoster_images__oxze5","landscape":"DailyTvPoster_landscape__DI9yM","portrait":"DailyTvPoster_portrait__BJJhh"};